import { SpeakableSpeechMark } from '../tts.constants';

type ProcessedSpeechMark = SpeakableSpeechMark & {
  processed?: boolean;
};

export function findSpeechMark({
  speechMarks,
  wordIndex,
  combinedText,
  lastTime,
  hasPlayedSpeechMarks,
}: {
  speechMarks: ProcessedSpeechMark[];
  wordIndex: number;
  combinedText: string;
  lastTime: number;
  hasPlayedSpeechMarks: boolean;
}) {
  const speechMarkIndex = hasPlayedSpeechMarks
    ? speechMarks.findIndex(
        mark =>
          mark.value === combinedText &&
          !mark.processed &&
          mark.indexInHtmlBody === wordIndex
      )
    : speechMarks.findIndex(
        mark =>
          mark.value === combinedText && !mark.processed && mark.time > lastTime
      );

  const previousSpeechMark = speechMarks[speechMarkIndex - 1];

  return speechMarkIndex > 0 && !previousSpeechMark?.processed
    ? null
    : speechMarks[speechMarkIndex];
}
